import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { Stack, Text } from '@fluentui/react';
import axios from 'axios';
import React from 'react';
import './App.css';
import { ZoryveDirectApp } from './apps/ZoryveDirect/ZoryveDirect.app';
import { SpinnerLoader } from './components/Invoker/Loader';
import { syncInit } from './sync';
import { HistoryResponse, loadHistory } from './History';

initializeIcons();

console.log('Environment', process.env.REACT_APP_ENV);

interface InitResponseData {
  keyword: string;
  metadata: Record<string, string>;
}

function App(): JSX.Element {
  const [flowExpired, setFlowExpired] = React.useState<boolean | undefined>(undefined);
  const [initResponseData, setInitResponseData] = React.useState<InitResponseData>();
  const [history, setHistory] = React.useState<HistoryResponse>();

  // LOAD HISTORY
  React.useEffect(() => {
    console.log('LOADING HISTORY...');
    loadHistory().then((res) => {
      console.log('HISTORY LOADED', res);
      setHistory(res);
    });
  }, []);

  // SYNC INIT
  React.useEffect(() => {
    syncInit()
      .then((response) => {
        setFlowExpired(false);
        setInitResponseData(response.data.session);
        console.log('InitResponseData', response.data.session, initResponseData);
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          if (error.response?.data.name === 'SESSION_EXPIRED') {
            setFlowExpired(true);
          }
        }
        console.log('Error', error);
      });
  }, []);

  if (flowExpired) {
    return (
      <Stack
        horizontalAlign="center"
        verticalAlign="center"
        style={{ height: '100%', width: '100%' }}
      >
        <Text
          style={{
            fontSize: '2rem',
            padding: '1rem',
            textAlign: 'center',
            verticalAlign: 'center',
          }}
        >
          Session Expired, please contact <a href="tel:1-844-995-4448">1-844-995-4448</a>
        </Text>
      </Stack>
    );
  }

  if (flowExpired === false && history !== undefined && initResponseData !== undefined) {
    return <ZoryveDirectApp history={history} initResponse={initResponseData} />;
  }

  return (
    <Stack
      horizontalAlign="center"
      verticalAlign="center"
      style={{ height: '100%', width: '100%' }}
    >
      <SpinnerLoader />
    </Stack>
  );
}

export default App;
